var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-694.000000, -789.000000)",
    fill: "#E2E3E3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(288.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card-Copy",
    transform: "translate(0.000000, 670.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-6",
    transform: "translate(373.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "description_black_24dp",
    transform: "translate(13.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,2 L6,2 C4.9,2 4.01,2.9 4.01,4 L4,20 C4,21.1 4.89,22 5.99,22 L18,22 C19.1,22 20,21.1 20,20 L20,8 L14,2 Z M16,18 L8,18 L8,16 L16,16 L16,18 Z M16,14 L8,14 L8,12 L16,12 L16,14 Z M13,9 L13,3.5 L18.5,9 L13,9 Z",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSolid);
export default __webpack_public_path__ + "static/media/document-solid.6454a410b9ab651263aceb5ee3694bac.svg";
export { ForwardRef as ReactComponent };